module.exports = __webpack_public_path__ + "mz.45909690df5ce5f2bb1f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mz.svg
// module chunks = styles